if (!customElements.get('video-link-carousel')) {
  class VideoLinkCarousel extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.videos = Array.from(this.querySelectorAll('.video-link-card__video'));
      this.visibleVideos = new Set();
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      this.handleMotionPreference = this.handleMotionPreference.bind(this);
      this.handleVisibilityChange = this.handleVisibilityChange.bind(this);

      this.videos.forEach((video) => {
        video.muted = true;
        video.playsInline = true;

        const card = video.closest('.video-link-card');
        const markReady = () => card?.classList.add('video-link-card--video-ready');
        const markError = () => {
          card?.classList.add('video-link-card--video-error');
          video.pause();
        };

        if (video.readyState >= 2) markReady();
        video.addEventListener('loadeddata', markReady, { once: true });
        video.addEventListener('error', markError, { capture: true, once: true });
      });

      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting && entry.intersectionRatio >= 0.35) {
                this.visibleVideos.add(entry.target);
                this.playVideo(entry.target);
              } else {
                this.visibleVideos.delete(entry.target);
                entry.target.pause();
              }
            });
          },
          { threshold: [0, 0.35, 1] }
        );

        this.videos.forEach((video) => this.observer.observe(video));
      } else {
        this.videos.forEach((video) => this.visibleVideos.add(video));
      }

      if (this.reduceMotion.addEventListener) {
        this.reduceMotion.addEventListener('change', this.handleMotionPreference);
      } else {
        this.reduceMotion.addListener(this.handleMotionPreference);
      }

      document.addEventListener('visibilitychange', this.handleVisibilityChange);
      this.handleMotionPreference();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      document.removeEventListener('visibilitychange', this.handleVisibilityChange);

      if (this.reduceMotion?.removeEventListener) {
        this.reduceMotion.removeEventListener('change', this.handleMotionPreference);
      } else {
        this.reduceMotion?.removeListener(this.handleMotionPreference);
      }

      this.videos?.forEach((video) => video.pause());
      this.initialized = false;
    }

    playVideo(video) {
      if (this.reduceMotion.matches || document.hidden) return;
      const playPromise = video.play();
      if (playPromise?.catch) playPromise.catch(() => {});
    }

    handleMotionPreference() {
      this.classList.toggle('video-link-carousel--reduce-motion', this.reduceMotion.matches);

      if (this.reduceMotion.matches) {
        this.videos.forEach((video) => video.pause());
      } else {
        this.visibleVideos.forEach((video) => this.playVideo(video));
      }
    }

    handleVisibilityChange() {
      if (document.hidden) {
        this.videos.forEach((video) => video.pause());
      } else if (!this.reduceMotion.matches) {
        this.visibleVideos.forEach((video) => this.playVideo(video));
      }
    }
  }

  customElements.define('video-link-carousel', VideoLinkCarousel);
}
